import React from 'react'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import PrivatePageSF from '../../templates/PrivatePageSF'
import TaskDetailSF from '../../components/projectapp/taskDetail/TaskDetailSF'
import TaskNotFoundUI from '../../components/projectapp/taskDetail/TaskNotFoundUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'

const TaskDetailPageUI = ({context, messageList, project, task, notFound, taskNumber,
    projectUserList, projectUserMap,
    // delete params
    deletingId, onDeleteClick, onCancelDeleteClick,
    onTaskListUpdated, onForceTaskListRefresh, onForceProjectUserListRefresh
  }) =>
  <PrivatePageSF context={context} className='pg_task_dtl'
    backLink={`/projects${project ? '/' + project.projectId + '/tasks' : ''}`}
    messageList={messageList}
    centered={!task || (!projectUserList && !notFound)}
    headerText={task ? task.taskName : ''}
  >
    {
      ((!task && !notFound) || (!projectUserList && !notFound)) &&
      <SpinnerComponentUI />
    }
    {
      !task && notFound &&
      <TaskNotFoundUI messageList={messageList} taskNumber={taskNumber} />
    }
    {
      task && projectUserList &&
      <React.Fragment>
        <PageTitleUI context={context} goBack={true}
          backLink={`/projects${project ? '/' + project.projectId + '/tasks' : ''}`}
          titleText={task ? task.taskName : ''}
        />
        <TaskDetailSF
          context={context}
          project={project}
          task={task}
          projectUserMap={projectUserMap}
          projectUserList={projectUserList}
          onTaskListUpdated={onTaskListUpdated}
          onForceTaskListRefresh={onForceTaskListRefresh}
          onForceProjectUserListRefresh={onForceProjectUserListRefresh}
        />
      </React.Fragment>
    }
  </PrivatePageSF>

export default TaskDetailPageUI
